export default {
  base: {
    border: '1px solid',
    borderColor: 'transparent',
    borderRadius: '0px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'base',
    lineHeight: '1.2',
    whiteSpace: 'nowrap',
    fontWeight: 'bold',
    transition: 'background-color 200ms ease',
    textDecoration: 'inherit',
    variant: 'spark.base.wrapper'
  },
  variants: {
    primary: {
      variant: 'spark.element.button.base',
      bg: 'primary',
      color: 'grey-0',
      hover: {
        bg: 'deepBlue'
      },
      focus: {
        outline: 'none',
        bg: 'cyan',
        color: 'deepBlue'
      },
      disabled: {
        bg: 'grey-30',
        color: 'grey-0'
      }
    },
    secondary: {
      variant: 'spark.element.button.base',
      bg: 'grey-10',
      color: 'grey-100',
      hover: {
        bg: 'grey-20'
      },
      focus: {
        outline: 'none',
        bg: 'cyan',
        color: 'deepBlue'
      },
      disabled: {
        bg: 'grey-05',
        color: 'grey-50'
      }
    },
    tertiary: {
      variant: 'spark.element.button.base',
      bg: 'grey-0',
      color: 'grey-100',
      borderColor: 'grey-20',
      hover: {
        bg: 'grey-05'
      },
      focus: {
        outline: 'none',
        bg: 'cyan',
        color: 'deepBlue'
      },
      disabled: {
        bg: 'grey-0',
        color: 'grey-40'
      }
    }
  }
};